import React from 'react';

interface ProductItem {
    image: string;
    alt?: string;
    link?: string;
}

interface ProductProps {
    products: ProductItem[];
    className?: string;
    aspectRatio?: 'nitrile' | 'disposable' | 'surface' | 'covid' | 'sanitizer';
}

const Product: React.FC<ProductProps> = ({ products, className = '' }) => {
    return (
        <div className={`w-full ${className}`}>
            {/* Responsive grid: 1 col below md (768px), 4 cols on md and above */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                {products.map((product, index) => (
                    <div 
                        key={index}
                        className="product-container mx-auto"
                    >
                        {product.link ? (
                            <a href={product.link} className="block w-full h-full flex items-center justify-center">
                                <img 
                                    src={product.image} 
                                    alt={product.alt || `Product ${index + 1}`}
                                    className="product-image"
                                    loading="lazy"
                                />
                            </a>
                        ) : (
                            <img 
                                src={product.image} 
                                alt={product.alt || `Product ${index + 1}`}
                                className="product-image"
                                loading="lazy"
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Product; 